"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getScrollTop = getScrollTop;
exports.getScrollLeft = getScrollLeft;
exports.getScrollHeight = getScrollHeight;
exports.getScrollWidth = getScrollWidth;
exports.getDocumentOffsetPosition = getDocumentOffsetPosition;
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function getScrollTop(el) {
    if (_instanceof(el, Window)) return window.pageYOffset || document.documentElement.scrollTop;
    return el.scrollTop;
}
function getScrollLeft(el) {
    if (_instanceof(el, Window)) return window.pageXOffset || document.documentElement.scrollLeft;
    return el.scrollLeft;
}
function getScrollHeight(el) {
    if (_instanceof(el, Window)) return document.documentElement.scrollHeight;
    return el.scrollHeight;
}
function getScrollWidth(el) {
    if (_instanceof(el, Window)) return document.documentElement.scrollWidth;
    return el.scrollWidth;
}
function getDocumentOffsetPosition(el) {
    var position = {
        top: _instanceof(el, Window) ? 0 : el.offsetTop,
        left: _instanceof(el, Window) ? 0 : el.offsetLeft
    };
    if (_instanceof(el, HTMLElement) && el.offsetParent) {
        var parentPosition = getDocumentOffsetPosition(el.offsetParent);
        position.top += parentPosition.top;
        position.left += parentPosition.left;
    }
    return position;
}
